import styled from "styled-components";

export const AssignmentButton = styled.button`
    display: flex;
    align-items: center;
    padding: 6px 12px 6px 3px;
    background: none;
    border: none;
    cursor: pointer;
    border-radius: 4px;
    transition: background-color 0.2s;
`;

export const ActionText = styled.span`
    padding-left: 0.5rem;

    &:hover {
        color: ${({ theme }) => theme.tokens.color.interaction.softHover} !important;
        text-decoration: underline;
    }
`;

export const AssignLink = styled.button<{ disabled?: boolean }>`
  background: none;
  border: none;
  color: ${({ theme, disabled }) =>
    disabled ? theme.tokens.color.text.disabled : theme.tokens.color.interaction.softDefault};
  font-size: 0.875rem;
  font-weight: 700;
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  padding: 0;
  text-decoration: ${({ disabled }) => disabled ? 'none' : 'underline'};
  font-family: 'LATAM Sans Regular', 'LATAM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  opacity: ${({ disabled }) => disabled ? 0.6 : 1};

  &:hover {
    color: ${({ theme, disabled }) =>
      disabled ? theme.tokens.color.text.disabled : theme.tokens.color.interaction.softHover};
    text-decoration: ${({ disabled }) => disabled ? 'none' : 'underline'};
  }
`;

export const AvatarWithLinkContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

/**
 * Hangar Avatar no expone color de tipografía para iniciales.
 * Se fuerza `text.primary` (equiv. diseño #303030) con mayor especificidad (`&&`) para no usar `!important`.
 * El hijo directo sigue siendo contrato implícito del Avatar; si Hangar cambia el DOM, habría que ajustar.
 */
export const AnalystAvatarWrap = styled.span`
  display: inline-flex;
  line-height: 0;

  && .fc-assignment-avatar > span {
    color: ${({ theme }) => theme.tokens.color.text.primary};
  }
`;
